"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExtractPath = void 0;
var _Loading = _interopRequireDefault(require("../Loading/Loading"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _array = require("../../utils/type-checks/array");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  ExtractPath = (dataArray, location) => {
    const {
      pathname,
      search,
      hash
    } = location;
    let filteredArray,
      result = "";
    if ((0, _array.isArrayOfLength)(dataArray)) {
      filteredArray = dataArray.filter(obj => obj.shortUrl === pathname);
      result = (0, _array.isArrayOfLength)(filteredArray) && (0, _string.isStringOfLength)(filteredArray[0].longUrl) ? filteredArray[0].longUrl + search + hash : "";
    }
    return result;
  };

/**
 * Component for expanding and redirecting short marketing links
 *
 * @visibleName Shorten Link
 * @author Jeff Stevens
*/
exports.ExtractPath = ExtractPath;
const ShortenLink = props => {
  const {
      customTheme = {},
      dataArray = [],
      testId,
      ...rest
    } = props,
    {
      location
    } = window,
    expandedPath = (0, _array.isArrayOfLength)(dataArray) ? ExtractPath(dataArray, location) : "",
    theme = merge((0, _styles.useTheme)(), customTheme);
  (0, _react.useEffect)(() => {
    if ((0, _string.isStringOfLength)(expandedPath)) {
      location.replace(location.origin + expandedPath);
    } else {
      location.replace(location.origin);
    }
  });
  return /*#__PURE__*/_react.default.createElement(_Loading.default, _extends({}, rest, {
    customTheme: theme,
    testId: testId
  }));
};

// Define propTypes;
ShortenLink.propTypes = {
  /** Custom Theme Object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Array containing short and long paths (Default Value: []) */
  dataArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** URL to forward the user to */
    longUrl: _propTypes.default.string,
    /** Shortened marketing URL */
    shortUrl: _propTypes.default.string
  })),
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = ShortenLink;